import React from "react";
import PlanList from "../../components/WhatsApp/Plans/PlanList";

const PlanManagement = () => {
  return <PlanList />;
};

export default PlanManagement;
